import {Box, Grid, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {getHomeInternalUrl} from "../../../constants/appRoutes";

const HubLogo = ({
  hub,
  headerLogoTitle,
  headerLogoHref,
  baseURL,
  headerLogoAlt,
  handleStyle,
  headerLogoSmallURL,
  isCollapsed,
  sx
}) => {
  const {t} = useTranslation();

  if ((!isCollapsed && hub.headerLogoURL) || (isCollapsed && headerLogoSmallURL)) {
    const img = (
      <img
        src={baseURL + (!isCollapsed ? hub.headerLogoURL : headerLogoSmallURL)}
        alt={headerLogoAlt}
        onLoad={handleStyle}
      />
    );

    return (
      <Grid className="hub-logo" sx={sx}>
        <Tooltip title={headerLogoTitle}>
          {headerLogoHref.length > 0 ? (
            <a
              href={headerLogoHref}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("components.header.hubLogo.ariaLabel")}
            >
              <Box
                component="span"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  "& img": {
                    height: "32px"
                  }
                }}
              >
                {img}
              </Box>
            </a>
          ) : (
            <Link to={getHomeInternalUrl()} aria-label={t("components.header.hubLogo.ariaLabel")}>
              <Box
                component="span"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  "& img": {
                    height: "32px"
                  }
                }}
              >
                {img}
              </Box>
            </Link>
          )}
        </Tooltip>
      </Grid>
    );
  } else {
    return null;
  }
};

export default HubLogo;
